var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
export var Container = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  transform: translateY(", ");\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background-color: ", ";\n  appearance: none;\n  cursor: pointer;\n  box-shadow: 0 0 0 0.2rem #fff, 0 0.1rem 0.2rem 0.2rem rgba(0, 0, 0, 0.1),\n    0 0 0.2rem 0.2rem rgba(0, 0, 0, 0.2);\n\n  svg {\n    width: 1.3rem;\n    fill: #fff;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  transform: translateY(", ");\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background-color: ", ";\n  appearance: none;\n  cursor: pointer;\n  box-shadow: 0 0 0 0.2rem #fff, 0 0.1rem 0.2rem 0.2rem rgba(0, 0, 0, 0.1),\n    0 0 0.2rem 0.2rem rgba(0, 0, 0, 0.2);\n\n  svg {\n    width: 1.3rem;\n    fill: #fff;\n  }\n"])), function (_a) {
  var isSelected = _a.isSelected;
  return isSelected ? "2.4rem" : "1.6rem";
}, function (_a) {
  var isSelected = _a.isSelected;
  return isSelected ? "2.4rem" : "1.6rem";
}, function (_a) {
  var isSelected = _a.isSelected;
  return isSelected ? "0.4rem" : 0;
}, function (_a) {
  var color = _a.color;
  return color;
});
var templateObject_1;